import React, { useState } from "react";
import config from "./config";
import * as Sentry from "@sentry/react";

const Login = () => {
    const [login, setLogin] = useState("")
    const [password, setPassword] = useState("")
    const [emailError, setEmailError] = useState("")
    const [passwordError, setPasswordError] = useState("")
    
        
    const onButtonClick = () => {

        // Set initial error values to empty
        setEmailError("")
        setPasswordError("")

        // Check if the user has entered both fields correctly
        if ("" === login) {
            setEmailError("Please enter your email")
            return
        }

        if ("" === password) {
            setPasswordError("Please enter a password")
            return
        }

        if (password.length < 1) {
            setPasswordError("The password must be 8 characters or longer")
            return
        }

        logIn()
  

    }

    // Log in a user using email and password
    const logIn = () => {
        fetch(config.apiBaseUrl + "/user/login", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
              },
            body: JSON.stringify({login, password})
        })
        .then(r => r.json())
        .then(r => {
            if (r.token) {
                localStorage.setItem("user", JSON.stringify({login, token: r.token, id: r.user.id}))
                window.location.assign("/")
            } else {
                Sentry.captureMessage("Token is empty in the login page", {
                    level: "error", // уровень ошибки: info, warning, error
                    extra: {
                        response: r,
                    },
                });
                window.alert("Wrong email or password")
            }
        }).catch(err => {
            Sentry.captureException(err);
            window.alert(err)
        })
    }

    return <div className={"mainContainer"}>
        <div className={"titleContainer"}>
            <div>Login</div>
        </div>
        <br />
        <div className={"inputContainer"}>
            <input
                value={login}
                placeholder="Enter your email here"
                onChange={ev => setLogin(ev.target.value)}
                className={"inputBox"} />
            <label className="errorLabel">{emailError}</label>
        </div>
        <br />
        <div className={"inputContainer"}>
            <input
                type="password"
                value={password}
                placeholder="Enter your password here"
                onChange={ev => setPassword(ev.target.value)}
                className={"inputBox"} />
            <label className="errorLabel">{passwordError}</label>
        </div>
        <br />
        <div className={"inputContainer"}>
            <input
                className={"inputButton"}
                type="button"
                onClick={onButtonClick}
                value={"Log in"} />
        </div>
    </div>
}

export default Login